export { default } from './CaseStudiesView';



// WEBPACK FOOTER //
// ./src/components/views/CaseStudiesView/index.js